/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const PolicyHolderDataRoutes: Routes = [
  {
    path: RoutePaths.NEW_QUOTATION.POLICY_HOLDER.POLICY_PARTICIPANT.route,
    loadChildren: () =>
      import('@pages/policy-holder-data/policy-participant/policy-participant.module').then(
        m => m.PolicyParticipantPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.POLICY_HOLDER.POLICY_HOLDER_DETAIL.route,
    loadChildren: () =>
      import('@pages/policy-holder-data/policy-holder-detail/policy-holder-detail.module').then(
        m => m.PolicyHolderDetailPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.POLICY_HOLDER.POLICY_HOLDER_RESIDENCE.route,
    loadChildren: () =>
      import('@pages/policy-holder-data/policy-holder-residence/policy-holder-residence.module').then(
        m => m.PolicyHolderResidencePageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.POLICY_HOLDER.HOME_ADDRESS.route,
    loadChildren: () =>
      import('@pages/policy-holder-data/home-address/home-address.module').then(m => m.HomeAddressPageModule),
    canActivate: [NavigationGuard],
  },
];
